import React, {Component} from '../../lib/react'
import connect from "react-redux/es/connect/connect";
import { Layout, Alert, Button, Spin } from 'antd'

import FilterPanel from "../../components/Modules/FilterPanel";
import PageHeader from "../../components/Modules/PageHeader";
import Info from '../../components/Modules/Info';
import AskForLogin from '../../components/Modules/AskForLogin';

import Events from "../../services/events";
import { auth, addView } from '../../services/firebase/firebase'
import { loadUserInfo } from '../../services/firebase/user'
import {getEntry} from '../../services/firebase/events'

import { updateEventAction } from "../../actions/eventsStoreActions";

import './watch.less'

const { Content } = Layout;

class Watch extends Component {
  state = {
    pageLoading: true,
    visibleRegistration: false,
    visibleAuth: true,
    markerLoading: false,
    loadingImportVideo: false,
    activeType: 'auth',
    userInfo: null,
  };

  async componentDidMount() {
    const id = this.props.params.id;
    const currentUser = auth().currentUser;
    let entry;

    try {
      entry = await getEntry(id);

      if (entry) {
        entry.views = entry.views + 1;
        entry && await this.props.updateEventAction(entry);
      }
    } catch(err){
      console.error(err);
      this.setState({loadingError: true});
      return
    }

    if (entry && entry.date) {
      if(currentUser) {
        await addView(id);
        const userInfo = await loadUserInfo(currentUser.uid);
        this.setState({ userInfo });
      }
    }

    this.setState({
      pageLoading: false,
      entry
    })
  }

  filterBy(field, value) {
    Events.setFilter(field, value);
    this.setState({refresh: Math.random()})
  }

  setStateHandler = (obj) => {
    this.setState(obj)
  }

  paymentPermissions () {
    const { channels, user } = this.props;
    const { userInfo, entry } = this.state;
    const { userType } = user.userClaims;
    const isAdmin = userType && (userType === 'Admin');

    const channelId = entry && entry.channel && entry.channel.id;
    const isBoughtEvent = entry && userInfo && userInfo.boughtEvents && userInfo.boughtEvents.find((eventId) => eventId === entry.id);
    const paidEvent = entry && entry.paidBlock && entry.paidBlock === "blocked";

    let eventOwnerId = false;
    channels && channels.map(channel => {
      if (channel.id === channelId) {
        if (!channel.ownerId) { // if channel haven't ownerId it's free channel
          eventOwnerId = true
        } else {
          eventOwnerId = channel.ownerId.find(ownerId => ownerId === user.uid);
        }
      }
    });

    return paidEvent ? (isAdmin || isBoughtEvent || !!eventOwnerId) : true;
  }

  render(){
    const { user, data } = this.props;
    const { entry, loadingError, pageLoading } = this.state;

    const permission = this.paymentPermissions();

    if (!auth().currentUser || !user || !user.uid) {
      return (
        <React.Fragment>
          <PageHeader
            backTo={'Past_Events/Surgeries'}
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Event search"
                  type="event"
                />
              </div>
            }
          />
          {
            loadingError && (
              <Alert message="Error retrieving data" type="warning" />
            )
          }
          <div className="container">
            <AskForLogin />
          </div>
        </React.Fragment>
      )
    }

    return (
      <Layout className="page-wrapper">
        <Content className="feed">
          <PageHeader
            backTo={'Past_Events/Surgeries'}
            extra={
              <div className="search-form">
                <FilterPanel
                  filter={this.filterBy}
                  title="Event search"
                  type="event"
                  deviceType
                />
              </div>
            }
            extraMobile={
              <Button type="primary" shape="circle" icon="search" />
            }
            mobileTitleSearch="Event search"
            mobileTypeSearch="event"
          />

          {
            loadingError && (
              <Alert message="Error retrieving data" type="warning" />
            )
          }
          {
            permission ? (
              <div className="">
                {
                  entry && (
                    <Info
                      entry={entry}
                      user={user}
                      data={data}
                      markerLoading={this.props.markerLoading}
                      loadingImportVideo={this.props.loadingImportVideo}
                      setStateHandler={this.setStateHandler}
                    />
                  )
                }
              </div>
            ) : (
              <h2>For watching this event, You need to buy permission.</h2>
            )
          }

          {
            pageLoading && (
              <div className="preloader-wr">
                <Spin className="preloader" />
              </div>
            )
          }
        </Content>
      </Layout>
    )
  }
}

export default connect(state => ({channels: state.data.channels}),{updateEventAction})(Watch);



// WEBPACK FOOTER //
// ./src/pages/Watch/index.js